import { PackagingTypeTrans } from '@typings/entities/Product'
import { Option as OptionType } from '@mailstep/design-system/ui/Elements/Select/types'

export const getPackagingTypeOptions = (): OptionType[] => [
  { value: 'A', label: PackagingTypeTrans.A() },
  { value: 'B', label: PackagingTypeTrans.B() },
]

export const salesabilityOptions: OptionType[] = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
]

export const codeTypeOptions = [
  { label: 'Ean8', value: 'ean8' },
  { label: 'Ean13', value: 'ean13' },
  { label: 'Ean14', value: 'ean14' },
  { label: 'Unknown', value: 'unknown' },
  { label: 'Upca', value: 'upcA' },
  { label: 'Upce', value: 'upcE' },
]
